<template lang="pug">
    Page.digital
        .digital__top(
            slot="header"
        )
            h1.digital__title
                | Район

            SvMenu(
                @remove="remove"
                @copy="copy"
            )

        SvTabs.digital__table(
            v-model="current"
            :tabs="['Район']"
        )
            .digital__actions
                SvButton.residential-edit__action(
                    view="secondary"
                    text="Отмена"
                    :prependIcon=`{
                        icon: 'cancel',
                        width: 24,
                        height: 24,
                        hover: '#1993EB',
                        default: '#B7BAC6'
                    }`
                    @click="resetForm"
                )

                SvButton.residential-edit__action(
                    view="secondary"
                    text="Применить"
                    :prependIcon=`{
                        icon: 'refresh',
                        width: 24,
                        height: 24,
                        hover: '#1993EB',
                        default: '#B7BAC6'
                    }`
                    @click="save(false)"
                )

                SvButton.residential-edit__action(
                    view="primary"
                    text="Сохранить"
                    :prependIcon=`{
                        icon: 'check',
                        width: 24,
                        height: 24,
                        default: '#1993EB',
                        hover: '#1993EB'
                    }`
                    @click="save(true)"
                )

        keep-alive
            FormDistrict(
                v-if="current === 0"
            )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {http} from '@/helpers/http';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import FormDistrict from '@/components/forms/FormDistrict.vue';

export default {
    name: "DistrictEdit",

    components: {
        Page,
        SvInput,
        SvButton,
        SvTable,
        SvMenu,
        SvTabs,
        FormDistrict,
    },

    beforeMount() {
        this.$store.dispatch('districts/getById', this.$route.params.id);
    },

    beforeRouteUpdate(to, from, next) {
        if (to.params.id !== 'new') {
            this.$store.dispatch('districts/getById', to.params.id);
        }
        next();
    },

    data() {
        return {
            current: 0,
        };
    },

    methods: {
        ...mapMutations({
            setValue: 'districts/setValue',
            clearCurrent: 'districts/clearCurrent',
        }),

        resetForm() {
            this.clearCurrent();
            this.$router.push({ name: 'districts' });
        },

        copy() {
            this.$store.commit('districts/setCurrent', this.$route.params.id);
            this.setValue({ id: null });
            this.$router.push({
                name: 'district-edit',
                params: {
                    id: 'new',
                },
            });
        },

        async remove() {
            await this.$store.dispatch('districts/remove', this.$route.params.id);
            this.$router.push({ name: 'districts' });
        },

        async save(isRedirect = false) {
            const id = await this.$store.dispatch('districts/save');
            if (!isRedirect) {
                this.$router.push({
                    name: 'district-edit',
                    params: {
                        id,
                    },
                }).catch(err => {});
            } else {
                this.$router.push({ name: 'districts' });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.digital__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.digital__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital__actions {
    display: flex;
    align-items: center;
    height: 100%;
}
</style>
